import { useEffect } from 'react'
import useNetworkStatus from '~/hooks/useNetworkStatus'

import {
  closeCustomNotification,
  showCustomNotification,
} from '../helperFunctions/customNotifications'

const NETWORK_THRESHOLD = 0.9
const SLOW_NETWORK_CONFIG = {
  MESSAGE: {
    TITLE: 'Slow Network Detected 😢 ',
    DESCRIPTION: 'You are on a slow network. Please check your connection for a faster experience.',
  },
  STYLING: {},
}
const OFFLINE_NETWORK_CONFIG = {
  MESSAGE: {
    TITLE: 'Offline Mode Detected 😢 ',
    DESCRIPTION: 'You are offline right now. Please check your connection for a better experience.',
  },
  STYLING: {},
}
export default function NetworkStatusChecker() {
  const { isSlowNetwork, isOfflineNetwork } = useNetworkStatus(NETWORK_THRESHOLD)

  useEffect(() => {
    if (isOfflineNetwork && !isSlowNetwork) {
      showCustomNotification({
        title: OFFLINE_NETWORK_CONFIG.MESSAGE.TITLE,
        message: OFFLINE_NETWORK_CONFIG.MESSAGE.DESCRIPTION,
      })
    } else if (isSlowNetwork && !isOfflineNetwork) {
      showCustomNotification({
        title: SLOW_NETWORK_CONFIG.MESSAGE.TITLE,
        message: SLOW_NETWORK_CONFIG.MESSAGE.DESCRIPTION,
      })
    } else {
      closeCustomNotification()
    }
  }, [isSlowNetwork, isOfflineNetwork])

  return null
}
